export default "/images/306d7580f80b822acd55fec7462b0f5d.avif";